import { createSlice } from '@reduxjs/toolkit'
import IUser from '../../../../interface/core/IUser'
import ISliceState from '../../../../interface/core/ISliceState'
import { sliceStateStatus } from '../../../../Core';

import {
    usersIndex
    , usersStore
    , usersReset
    , usersDestroy
    , usersCreate
    , usersSearch
    , usersPaginate
} from './usersActions'

const initialState: ISliceState = {
  data: new Array<IUser>(),
  status: sliceStateStatus.idle
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
   /*setAuthData(state, action: PayloadAction<IAuthData>) {

      //console.log('reduxtoolkit: setFormData:');
      //console.log(action.payload);

      //state = action.payload

      console.log('reduxtoolkit: action.payload:');
      console.log(action.payload);

      return action.payload
    },
    resetAuthData(state, action: PayloadAction<IAuthData>) {
      return initialState
    }*/
  },
  extraReducers: (builder) => {
    builder
        .addCase(usersReset, () => {return initialState;})
        
        /*.addCase(logout.fulfilled, (state, action) => {
          console.log('logout');
          console.log(action.payload);

          //state = action.payload;
          //setAuthData(action.payload);
          //Object.assign(state, action.payload);
          return initialState;
        })
        .addCase(logout.rejected, (state, action) => {

          console.log('logout.rejected');
          console.log(action.error);

          return state;
        })*/
        /*.addCase(everyone, (state, action) => {

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
            }

            axios.post('api/everyone', {}, config);
            return initialState;
        })
        .addCase(usersIndex.fulfilled, (state, action) => {
          //state = action.payload;
          return action.payload;
        })
        .addCase(usersIndex.pending, (state, action) => {
          state.status = 'pending';
          return state;
        })
        .addCase(usersIndex.rejected, (state, action) => {
          state.status = 'failed';
          return state;
        })
        */

        .addCase(usersIndex.fulfilled, (state, action) => {
          state.data = action.payload.data; 
          state.status = sliceStateStatus.fulfilled; 
        })
        .addCase(usersIndex.pending, (state, action) => {
          state.status = sliceStateStatus.pending;
        })
        .addCase(usersIndex.rejected, (state, action) => {
          state.status = sliceStateStatus.rejected;
        })
        .addCase(usersStore.fulfilled, (state, action) => {
          //console.log('login');
          //console.log(action);

          //state = action.payload;
          //setAuthData(action.payload);
          //Object.assign(state, action.payload);
          //return action.payload;
        })
        .addCase(usersDestroy.fulfilled, (state, action) => {
          //state.data = action.payload.data; 
          state.status = sliceStateStatus.fulfilled; 
        })
        .addCase(usersDestroy.pending, (state, action) => {
          state.status = sliceStateStatus.pending;
        })
        .addCase(usersDestroy.rejected, (state, action) => {
          state.status = sliceStateStatus.rejected;
        })

        .addCase(usersCreate.fulfilled, (state, action) => {
          state.status = sliceStateStatus.fulfilled; 
        })
        .addCase(usersCreate.pending, (state, action) => {
          state.status = sliceStateStatus.pending;
        })
        .addCase(usersCreate.rejected, (state, action) => {
          state.status = sliceStateStatus.rejected;
        })

        .addCase(usersSearch.fulfilled, (state, action) => {
          state.data = action.payload.data; 
          state.status = sliceStateStatus.fulfilled; 
        })
        .addCase(usersSearch.pending, (state, action) => {
          state.status = sliceStateStatus.pending;
        })
        .addCase(usersSearch.rejected, (state, action) => {
          state.status = sliceStateStatus.rejected;
        })

        .addCase(usersPaginate.fulfilled, (state, action) => {
          state.data = action.payload.data; 
          state.status = sliceStateStatus.fulfilled; 
        })
        .addCase(usersPaginate.pending, (state, action) => {
          state.status = sliceStateStatus.pending;
        })
        .addCase(usersPaginate.rejected, (state, action) => {
          state.status = sliceStateStatus.rejected;
        })
        

  }
})

export default usersSlice.reducer
